qtee.customDesign = window.qtee.customDesign || {};

// Settings
qtee.customDesign.settings = {};

qtee.customDesign.settings.domain = 'https://www.lampsplus.com';
qtee.customDesign.settings.path = '/customphoto/editor';

// check if device is touchable
qtee.customDesign.settings.isTouch = function () {

	if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {

		return true;

	}

	return false;

};

// Loader shows up after this threshold
qtee.customDesign.settings.loaderThreshold = 1000;

// Free transform default options for elements
qtee.customDesign.settings.freetransform = {
	options: {
		// we can't use 'transparent' for fill because IE doesn't pass mouse events to SVG rect with fill: 'transparent'
		attrs: { fill: 'rgba(255, 255, 255, 0.75)', stroke: '#000000' },
		draw: [ 'bbox' ],
		distance: 2.3,
		drag: 'self',
		keepRatio: [ 'axisX', 'axisY', 'bboxCorners', 'bboxSides' ],
		// range.scale is not limit for scale value, it's limit for actuall size of element
		range: { rotate: [ -180, 180 ], scale: [ 10, 'Infinity' ] },
		rotate: true,
		scale: ['bboxCorners', 'bboxSides'],
		size: qtee.customDesign.settings.isTouch() ? 14 : 12,
		snap: { drag: 0, rotate: 0, scale: 0 },
		snapDist: { drag: 7, rotate: 5, scale: 10 },
		boundary: { x: 0.45, y: 0.45 },
		undrag: false,
		onlyCorners: true,
		// force FreeTransform plugin to use first element in a set for bounding set
		takeFirstFromSet: true
	}
};

// Text
qtee.customDesign.settings.text = {
	// save text no more than once per
	milliseconds: 2000
};

// Designs
qtee.customDesign.settings.designs = {
	preview: { width: 205, height: 205 }
};

// Backgrounds
qtee.customDesign.settings.backgrounds = {
	preview: { width: 435, height: 205 }
};

// Fonts settings
qtee.customDesign.settings.fonts = {
	fontsPath: '/fonts/custom-design/',
	fontsImgPath: '/Images/custom-design/fonts/',
	weights: {
		thin: 250,
		extraLight: 275,
		light: 300,
		regular: 400,
		medium: 500,
		semiBold: 600,
		bold: 700,
		extraBold: 800,
		black: 900
	},
	flags: {
		thin: 1,
		thinItalic: 2,
		extraLight: 4,
		extraLightItalic: 8,
		light: 16,
		lightItalic: 32,
		regular: 64,
		regularItalic: 128,
		medium: 256,
		mediumItalic: 512,
		semiBold: 1024,
		semiBoldItalic: 2048,
		bold: 4096,
		boldItalic: 8192,
		extraBold: 16384,
		extraBoldItalic: 32768,
		black: 65536,
		blackItalic: 131072
	}
};
// Fonts list
qtee.customDesign.settings.fonts.list = (function (f) {

	return [
		{ name: 'Abril Fatface', style: f.regular },
		{
			name: 'Alegreya Sans',
			style:
				f.regular |
				f.regularItalic |
				f.thin |
				f.thinItalic |
				f.light |
				f.lightItalic |
				f.medium |
				f.mediumItalic |
				f.bold |
				f.boldItalic |
				f.extraBold |
				f.extraBoldItalic |
				f.black |
				f.blackItalic
		},
		{ name: 'Alex Brush', style: f.regular },
		{ name: 'Amatic SC', style: f.regular | f.bold },
		{ name: 'Covered By Your Grace', style: f.regular },
		{ name: 'Cutive Mono', style: f.regular },
		{ name: 'Dancing Script', style: f.regular | f.bold },
		{ name: 'Graduate', style: f.regular },
		{ name: 'Homemade Apple', style: f.regular },
		{ name: 'La Belle Aurore', style: f.regular },
		{
			name: 'Merriweather',
			style:
				f.light | f.lightItalic | f.regular | f.regularItalic | f.bold | f.boldItalic | f.black | f.blackItalic
		},
		{ name: 'Open Sans', style: f.regular | f.regularItalic | f.bold },
		{ name: 'Pacifico', style: f.regular },
		{ name: 'Permanent Marker', style: f.regular },
		{ name: 'Poiret One', style: f.regular },
		{ name: 'Pompiere', style: f.regular },
		{ name: 'PT Mono', style: f.regular },
		{ name: 'Quattrocento', style: f.regular | f.bold },
		{
			name: 'Raleway',
			style:
				f.thin |
				f.thinItalic |
				f.extraLight |
				f.extraLightItalic |
				f.light |
				f.lightItalic |
				f.regular |
				f.regularItalic |
				f.medium |
				f.mediumItalic |
				f.semiBold |
				f.semiBoldItalic |
				f.bold |
				f.boldItalic |
				f.extraBold |
				f.extraBoldItalic |
				f.black |
				f.blackItalic
		},
		{ name: 'Rock Salt', style: f.regular },
		{ name: 'Shadows Into Light', style: f.regular },
		{ name: 'Shadows Into Light Two', style: f.regular },
		{ name: 'Sigmar One', style: f.regular },
		{ name: 'Special Elite', style: f.regular }
	];

})(qtee.customDesign.settings.fonts.flags);

// Default attributes for new elements
qtee.customDesign.settings.newEl = {
	text: {
		rotation: 0,
		fontSize: 42,
		fontFamily: qtee.customDesign.settings.fonts.list[11].name,
		fontBold: false,
		fontItalic: false,
		fill: { r: 0, g: 0, b: 0 }
	},
	image: {
		width: 420,
		height: 420,
		rotation: 0,
		scale: 1
	},
	design: {
		width: 420,
		height: 420,
		rotation: 0,
		scale: 1
	},
	designLampshade: {
		width: 900,
		height: 422,
		rotation: 0,
		scale: 1
	},
	background: {
		width: 1023.2,
		height: 480,
		rotation: 0,
		scale: 1
	},
	backgroundLampshade: {
		width: 900,
		height: 422,
		rotation: 0,
		scale: 1
	}
};

// Limits
qtee.customDesign.settings.limits = {
	image: 5,
	text: 3,
	design: 5,
	// history states
	history: 10,
	// length of text elements
	textLength: 50,
	// characters validation
	textValid: function (text) {

		return text.length <= this.textLength;

	}
};

// Events on which model would be saved, array of regular expressions
qtee.customDesign.settings.onSaveEvents = [
	{ preEvent: /^(apply|drag)$/, event: /^drag end$/ },
	{ preEvent: /^(apply|rotate)$/, event: /^rotate end$/ },
	{ preEvent: /^(apply|scale)$/, event: /^scale end$/ }
];

// Relations between different names of elements
qtee.customDesign.settings.names = {
	text: {
		collection: 'text', // name of collection inside customized product model
		elements: 'TextSprites', // name of element's collection from server respond
		element: 'CustomizedText', // name of single element from server respond
		plugin: 'ShapedTextElement' // name of plugin to show element inside svg
	},
	uploadedimage: {
		collection: 'image',
		elements: 'ImageSprites',
		element: 'CustomizedImage',
		plugin: 'ImageElement'
	},
	pattern: {
		collection: 'pattern',
		elements: 'PatternSprites',
		element: 'CustomizedPattern',
		plugin: 'DesignElement'
	}
};

// Category to size chart's url mapping
qtee.customDesign.settings.categoryToSizeChartMapping = {
	'Qtee Shirts': '/Products/SizeChart',
	'Qtee Underwear': '/Products/SizeChart?category=qtee-underwear',
	'Qtee Sweatshirts': '/Products/SizeChart?category=qtee-sweatshirt',
	'Qtee Sweatpants': '/Products/SizeChart?category=qtee-sweatpants'
};

qtee.customDesign.settings.defaultSku = '15M05';
